"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spinner = exports.CSS = void 0;
var mithril_1 = require("../../mithril");
var scale_1 = require("../animation/scale");
var spin_1 = require("../animation/spin");
var theme_1 = require("../theme");
var theme_palette_1 = require("../theme.palette");
exports.CSS = {
    container: 'c-Spinner',
    isExiting: 'c-Spinner--is-exiting',
    circle: 'c-Spinner__circle',
    buttonSize: 'c-Spinner--big'
};
var FADE_TIME = 150;
var SPIN_TIME = 1100;
var CONTAINER_SIZE = theme_1.DefaultTheme.space(6);
var CIRCLE_SIZE = theme_1.DefaultTheme.space(4);
(0, theme_1.addStyles)((_a = {},
    _a[exports.CSS.container] = {
        width: CONTAINER_SIZE,
        height: CONTAINER_SIZE,
        'align-self': 'center',
        animation: "".concat(scale_1.SCALE.IN, " ").concat(FADE_TIME, "ms")
    },
    _a[exports.CSS.circle] = {
        height: CIRCLE_SIZE,
        width: CIRCLE_SIZE,
        margin: '2px',
        border: "2px solid ".concat((0, theme_1.rgba)(theme_palette_1.GOOGLE_BLUE)),
        borderTopColor: 'transparent',
        borderRadius: '50%',
        animation: "".concat(spin_1.SPIN, " ").concat(SPIN_TIME, "ms infinite linear")
    },
    _a[exports.CSS.buttonSize] = {
        width: theme_1.DefaultTheme.space(8)
    },
    _a['mdl-button .' + exports.CSS.container] = {
        margin: 'auto'
    },
    _a));
function view(className) {
    if (className === void 0) { className = ''; }
    return (0, mithril_1.m)('div', { className: "".concat(exports.CSS.container, " ").concat(className) }, [
        (0, mithril_1.m)('div', { className: exports.CSS.circle })
    ]);
}
exports.Spinner = { view: view, CSS: exports.CSS };
//# sourceMappingURL=spinner.js.map